/* Dependencies */
import styled from 'styled-components';
import GirlMail from '../assets/girl-mail.svg';
import InArrow from '../assets/in-arrow.svg';
import OutArrow from '../assets/out-arrow.svg';
import OpenBox from '../assets/open-box.svg';
import Inbox from '../assets/inbox.svg';
import Download from '../assets/download.svg';
import React from 'react';

export const Icon = styled.img`
  width: 16px;
  height: 16px;

  ${({ theme }) => theme.breakPoints.mobile} {
    margin: auto;
  }
  ${({ theme }) => theme.breakPoints.tablet} {
    margin: 0 10px 0 0;
  }
`;

export const SVGImageContainer = styled.div.attrs(() => ({
  className: 'ImagesContainer',
}))`
  width: 100%;
  max-height: 210px;
  margin-left: auto;
  margin-right: auto;
  display: inline-flex;
  justify-content: center;
`;

const SVGImage = styled.img<any>`
  height: ${({ isInbox }: any) => (isInbox ? '80px' : 'auto')};
  width: auto;
  padding: ${({ isInbox }: any) => (isInbox ? '0' : '40px 0')};
  margin-bottom: ${({ top }: any) => !top ? '0' : '64px'};}
  animation: fadeInAnimation ease 1s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;

  @keyframes fadeInAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const SVGImagesSet = () => {
  const imagesProps = (index: number) => {
    const top = Boolean(index > 0 && index < 4);
    const isInbox = index === 2;

    return { top, isInbox };
  };
  const ImagesSet = [
    GirlMail,
    InArrow,
    Inbox,
    OutArrow,
    OpenBox,
  ].map(
    (image, index) => (<SVGImage key={index} src={image} {...imagesProps(index)} />),
  );

  return (
    <>
      <SVGImageContainer>
        {ImagesSet}
      </SVGImageContainer>
    </>
  );
};

export const DownloadIcon = () => (<Icon src={Download} />);
